export const areObjectsEqual = (
  obj1: { [x: string]: any } | null | undefined,
  obj2: { [x: string]: any } | null | undefined,
) => {
  if (obj1 === undefined && obj2 === undefined) return true;
  if (obj1 === undefined || obj2 === undefined) return true;
  if (obj1 === null && obj2 === null) return true;
  if (obj1 === null || obj2 === null) return false;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every((key) => obj2[key] === obj1[key]);
};
